import React, { Component, Fragment } from 'react';
import AccordionLink from '../AccordionLink';
import { FooterSection, FooterTitle, FooterList, FooterLink, } from '../../styled';
import { sendAmpEvent } from '../../helpers';
const SpecialFooterLink = () => (React.createElement(FooterLink, { href: "#", className: "bannerLink", onClick: (e) => {
        e.preventDefault();
        illow.showWidget();
    } }, "My Privacy Choices"));
class Sections extends Component {
    constructor(props) {
        super(props);
        this.trackClick = (link) => {
            if (link.match('sell.bitcoin.com'))
                sendAmpEvent('sell_cta_clicked', {
                    web_location: 'footer',
                    pageview: window.location.href,
                });
            if (link.match('buy.bitcoin.com'))
                sendAmpEvent('buy_cta_clicked', {
                    web_location: 'footer',
                    pageview: window.location.href,
                });
        };
        this.trackClick = this.trackClick.bind(this);
    }
    render() {
        const { links } = this.props;
        const location = localStorage.getItem('bitcoincom-country') || '';
        return (React.createElement(React.Fragment, null, links.map(({ id, message, links: catLinks }) => (React.createElement(FooterSection, { key: id, area: id },
            React.createElement(FooterTitle, null,
                React.createElement("span", null, message)),
            React.createElement(FooterList, null, catLinks.map(({ href: catLink, message: catTitle, restricted = [], sublinks = [], }) => {
                if (restricted.includes(location)) {
                    return null;
                }
                if (sublinks.length > 0) {
                    return (React.createElement(Fragment, { key: catLink },
                        React.createElement(AccordionLink, { catTitle: catTitle, catLink: catLink, sublinks: sublinks })));
                }
                if (catTitle === 'My Privacy Choices') {
                    return React.createElement(SpecialFooterLink, { key: catTitle });
                }
                return (React.createElement(FooterLink, { key: catTitle, href: catLink, className: "universal-footer-link", onClick: () => {
                        this.trackClick(catLink);
                    } }, catTitle));
            })))))));
    }
}
export default Sections;
//# sourceMappingURL=Sections.js.map